export default __webpack_public_path__ + "static/media/DtVjJx26TKEr37c9aBpJn3YO5gjupg.c98acfcb.woff2";